// orderProjectCertification
export const ORDER_PROJ_CERT_FORM__FORM_FIELDS = 'ORDER_PROJ_CERT_FORM__FORM_FIELDS';
export const ORDER_PROJ_CERT_FORM__CHANGE_CURRENT_PAGE = 'ORDER_PROJ_CERT_FORM__CHANGE_CURRENT_PAGE';

// projectRegistrationForm
export const PROJECT_REGISTRATION_FORM = {
  UPDATE_COUNTRY_OPTIONS: 'UPDATE_COUNTRY_OPTIONS',
  UPDATE_ID: 'UPDATE_ID',
  FORM_FIELDS: 'FORM_FIELDS',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// RequestInspectionForm
export const REQUEST_INSPECTION_FORM = {
  FORM_FIELDS: 'FORM_FIELDS',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// projectCloseoutForm
export const PROJECT_CLOSEOUT_FORM = {
  UPDATE_COUNTRY_OPTIONS: 'UPDATE_COUNTRY_OPTIONS',
  FORM_FIELDS: 'FORM_FIELDS',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// projectUpdateForm
export const PROJECT_UPDATE_FORM = {
  UPDATE_COUNTRY_OPTIONS: 'UPDATE_COUNTRY_OPTIONS',
  FORM_FIELDS: 'FORM_FIELDS',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// projectQualifyCredentials
export const QUALIFY_CREDENTIALS_FORM = {
  UPDATE_COUNTRY_OPTIONS: 'UPDATE_COUNTRY_OPTIONS',
  FORM_FIELDS: 'FORM_FIELDS',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};
// projectDraftingAccredition
export const DRAFTING_ACCREDITION_FORM = {
  UPDATE_COUNTRY_OPTIONS: 'UPDATE_COUNTRY_OPTIONS',
  FORM_FIELDS: 'FORM_FIELDS',
  UPDATE_PRICE: 'UPDATE_PRICE',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// applyForLicensing
export const APPLY_FOR_LICENSING_FORM = {
  UPDATE_COUNTRY_OPTIONS: 'UPDATE_COUNTRY_OPTIONS',
  FORM_FIELDS: 'FORM_FIELDS',
  UPDATE_PRICE: 'UPDATE_PRICE',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// projectCertification
export const PROJECT_CERTIFICATION_FORM = {
  UPDATE_COUNTRY_OPTIONS: 'UPDATE_COUNTRY_OPTIONS',
  FORM_FIELDS: 'FORM_FIELDS',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// renewalForm
export const RENEWAL_FORM = {
  UPDATE_LATE_FEE: 'UPDATE_LATE_FEE',
  UPDATE_RENEWAL_FEE: 'UPDATE_RENEWAL_FEE',
  FORM_FIELDS: 'FORM_FIELDS',
  CHANGE_CURRENT_PAGE: 'CHANGE_CURRENT_PAGE',
  TOGGLE_SUBMITTING_STATE: 'TOGGLE_SUBMITTING_STATE',
  TOGGLE_SUBMITTED_STATE: 'TOGGLE_SUBMITTED_STATE',
};

// tests
export const TESTS = {
  QUESTIONS: 'QUESTIONS',
  TEST_DATA: 'TEST_DATA',
  CONTACT_DATA: 'CONTACT_DATA',
  UPDATE_SELECT_ANSWER: 'UPDATE_SELECT_ANSWER',
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
};